import { ITask } from "../task.interface";

export class TaskBoard {
  constructor(
    public name: string,
    public columns: TaskBoardColumn[]
  ) { }
}

export class TaskBoardColumn {
  constructor(
    public name: string,
    public value: string,
    public tasks: TaskBoardItem[]
  ) { }
}

export class TaskBoardItem {
  constructor(
    public name: string,
    public task: ITask,
    public workers: any,
  ) { }
}

